import HeaderTypeahead from './Header.Typeahead.js';
export default HeaderTypeahead;
//# sourceMappingURL=index.js.map